import * as Yup from 'yup';

export const FEEDBACK_CATEGORIES = ['improvement', 'issue', 'other'];

export const FEEDBACK_LIMITS = {
  messageMin: 5,
  messageMax: 2000,
  maxFiles: 5,
  maxFileBytes: 25 * 1024 * 1024,
  maxTotalBytes: 50 * 1024 * 1024,
  acceptedMimePrefixes: ['image/', 'video/'],
};

/**
 * Build the Yup schema for the feedback form. `forms` is the i18n
 * `forms` slice so validation messages stay localizable.
 *
 * Note: file-level validation happens in validateFiles.js before the
 * file reaches Formik state — by the time we validate here, files in
 * `attachments` have already passed mime/size/count checks. The schema
 * only re-asserts the count cap as a belt-and-braces guard.
 */
export const buildFeedbackSchema = forms =>
  Yup.object().shape({
    category: Yup.string()
      .oneOf(FEEDBACK_CATEGORIES, forms?.required || 'Required')
      .required(forms?.required || 'Required'),
    message: Yup.string()
      .trim()
      .min(FEEDBACK_LIMITS.messageMin, forms?.messageTooShort || 'Please add a bit more detail.')
      .max(FEEDBACK_LIMITS.messageMax, forms?.messageTooLong || 'Message is too long.')
      .required(forms?.required || 'Required'),
    attachments: Yup.array().max(FEEDBACK_LIMITS.maxFiles),
  });
